import { createContext, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { downloadHelpers } from '../libs/helpers';
import { trackEvent } from '../redux/analytics/analytics.reducer';

const { downloadFile } = downloadHelpers;

const DownloadBookContext = createContext({
    showModal: false,
    showModalHandler: () => {},
    hideModalHandler: () => {},

    book: { file: '', name: '', id: '' },
    setBookHandler: () => {},
    downloadBookHandler: () => {},
});

const DownloadBookProvider = ({ children }) => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [book, setBook] = useState({});

    const showModalHandler = () => setShowModal(true);
    const hideModalHandler = () => setShowModal(false);

    const setBookHandler = (newBook) => {
        setBook(newBook);
    };

    const downloadBookHandler = () => {
        const outcome = downloadFile(book);
        dispatch(trackEvent({
            name: outcome.status === 'started' ? 'workbook_download_started' : 'workbook_download_failed',
            params: {
                book_id: book.id,
                book_name: book.name,
                ...(outcome.reason ? { failure_reason: outcome.reason } : {}),
            },
        }));
        return outcome;
    };

    const value = {
        showModal,
        showModalHandler,
        hideModalHandler,
        book,
        setBookHandler,
        downloadBookHandler,
    };

    return <DownloadBookContext.Provider value={value}>{children}</DownloadBookContext.Provider>;
};

const useDownloadBook = () => {
    const context = useContext(DownloadBookContext);

    if (context === undefined) {
        throw new Error('DownloadBookContext was used outside of DownloadBookProvider.');
    }

    return context;
};

export { DownloadBookProvider, useDownloadBook };
